function getBrowserSizes(browserSize) {
    return (
        browserSize && {
            browserWidth: browserSize.browserWidth,
            browserHeight: browserSize.browserHeight,
            screenWidth: browserSize.screenWidth,
            screenHeight: browserSize.screenHeight,
            screenPixelRatio: browserSize.screenPixelRatio,
        }
    );
}

export function createStartPageStatistics(viewId, viewType, browserSize = null) {
    return {
        orvestoData: '/forstasida/lop/index',
        dataLake: {
            product: {
                viewId: viewId,
                viewType: viewType,
            },
            eventValues: getBrowserSizes(browserSize),
        },
    };
}

export function createVideoStatistics(
    titleSlug,
    episodeTitleSlug,
    svtId,
    viewId = null,
    viewType = null,
    browserSize = null
) {
    return {
        orvestoData: `/program/${titleSlug}/${episodeTitleSlug}`,

        dataLake: {
            content: {
                id: svtId,
            },
            product: {
                viewId,
                viewType,
            },
            eventValues: getBrowserSizes(browserSize),
        },
    };
}

export function createTitleStatistics(titleSlug, svtId, viewId = null, viewType = null, browserSize = null) {
    return {
        orvestoData: `/program/${titleSlug}/index`,

        dataLake: {
            content: {
                id: svtId,
            },
            product: {
                viewId,
                viewType,
            },
            eventValues: getBrowserSizes(browserSize),
        },
    };
}

export const createGenreStatistics = (slug, viewId = null, viewType = null, browserSize = null) => {
    return {
        orvestoData: `/${slug}/lop/index`,
        dataLake: {
            content: {
                id: slug,
            },
            product: {
                viewId,
                viewType,
            },
            eventValues: getBrowserSizes(browserSize),
        },
    };
};
